export default {
  'search_text': '搜索',
  'tab_common': '全部区域/国家',
  'tab_popular': '重点关注国家',
  'title_overall': '聚合数据',
  'title_region': '区域',
  'title_market': '市场',
  'title_popular': '重点关注',
  'title_country': '国家',
  'select_all': '全选',
  'clear_all': '清空',
  'no_data': '无匹配项',
  'global': '全部',
  'global_except_china': '全球除中国大陆',
  'global_no_data_text': '包括来自游戏商店和社交媒体的评论。',
  'unidentified_no_data_text': '包括所有无法与市场区分开来的社交媒体中的关键字监控和部分帐户监控的评论。',
  'global_message': '全球包括来自游戏商店和社交媒体的评论，无法与地区/市场区分开来。'
}